"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");



















































































var _user = require("@/utils/user");


var _formatter = require("@/utils/formatter");



var _mechanism = _interopRequireDefault(require("@/components/Cascader/mechanism.vue")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Mechanism: _mechanism.default }, data: function data() {return { tableData: [], // 列表数据
      brandCodeList: [], //品牌列表
      searchData: { insId: '', name: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { id: '', insId: '', code: '', name: '', brandCode: '' }, defaultData: { id: '', insId: '', code: '', name: '', brandCode: '' }, // 表格列
      tableColumns: [{ prop: 'code', label: '通用app编码', isShow: true }, { prop: 'name', label: '通用app名称', isShow: true }, { prop: 'brandCode', label: '品牌', isShow: true }, { prop: 'insName', label: '所属组织', isShow: true }, { prop: 'operatorName', label: '操作人员', isShow: true }, { prop: 'updateTime', label: '操作时间', formatter: _formatter.dateFormatter, isShow: true }], rules: { name: [{ required: true, message: '请输入通用app名称', trigger: 'blur' }], code: [{ required: true, message: '请输入通用app编码', trigger: 'blur' }], insId: [{ required: true, message: '请选择所属组织', trigger: 'change' }], brandCode: [{ required: true, message: '请选择所属品牌',
          trigger: 'change' }] } };



  },
  mounted: function mounted() {
    var self = this;
    self.init();
    self.getFaBrandInfoList();
  },
  methods: {
    init: function init() {
      var self = this;
      self.getData('/api/faPlat/', self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    checkPermission: _user.checkPermission,
    // 设置imageList
    resetFun: function resetFun() {// 重置
      this.searchData.name = '';
      this.searchData.insId = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },

    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faPlat/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    getFaBrandInfoList: function getFaBrandInfoList() {
      var self = this;
      self.getData('/api/faBrandInfo/list', {}, function (res) {
        self.brandCodeList = res;
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faPlat', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },

    updateMenu: function updateMenu(item) {
      this.title = '编辑';
      var self = this;
      // 编辑时展示图片
      self.addData = {
        id: item.id,
        code: item.code,
        name: item.name,
        insId: item.insId,
        brandCode: item.brandCode + '' };

      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faPlat/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
            // 清空数据
            self.addData = {};
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    changeMechanism: function changeMechanism(val) {
      this.searchData.insId = val;
    },
    changeMechanism2: function changeMechanism2(val) {
      this.addData.insId = val;
    } } };exports.default = _default;